import { CareerId } from '@common/const/catalog/career';
import { ROUTES_DEFAULT_CITY_ID } from '@common/const/routes/defaultCity';
import { CatalogItemType } from '@common/model/catalog/item/type';
import { CatalogFeedbacksProps } from 'src/widgets/catalog/feedback/list/types';

export const HOME_CAREER_LIST_MAX_WIDTH = 1396;

export const HOME_FEEDBACKS_LIST_PARAMETERS: CatalogFeedbacksProps = {
  careerId: CareerId.Nanny,
  catalogType: CatalogItemType.Resume,
  cityId: ROUTES_DEFAULT_CITY_ID,
  productName: 'Домашний персонал',
};

export const sliderConfig = {
  slidesPerView: 4,
  spaceBetween: 20,
  loop: true,
  breakpoints: {
    0: {
      slidesPerView: 1.3,
      spaceBetween: 12,
    },
    400: {
      slidesPerView: 1.6,
    },
    500: {
      slidesPerView: 2.15,
    },
    680: {
      slidesPerView: 3.15,
      spaceBetween: 16,
    },
    850: {
      slidesPerView: 3.5,
      spaceBetween: 16,
    },
    1050: {
      slidesPerView: 3.8,
      spaceBetween: 20,
    },
    1220: {
      slidesPerView: 4,
      spaceBetween: 20,
    },
  },
};
